// extracted by mini-css-extract-plugin
module.exports = {"postBox":"style_postBox__2p5-7","img":"style_img__i3_-2","postBody":"style_postBody__3NLoO"};